export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
`;
import styled from "styled-components";

export const CardService = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: 0.4s;
  width: 100%;

  &:hover {
    box-shadow: var(--shadowHoverCard);
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

export const FirstBox = styled.div`
  display: flex;
  align-items: start;
  gap: 8px;
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-wrap: nowrap;
`;

export const BoxIcon = styled.div<{ $hasImage?: boolean }>`
  width: 42px;
  height: 42px;
  border-radius: 8px;
  overflow: hidden;
  background: ${({ $hasImage }) =>
    $hasImage
      ? "var(--backgroundColorSecondary, #f2f2f2)"
      : "var(--primarySystem)"};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 18px;
    height: 18px;
    path,
    circle {
      stroke: var(--primarySystem100);
    }
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
`;

export const TitleCard = styled.h3`
  font-family: "Inter Medium";
  font-size: 16px;
  color: var(--colorTitle);
  display: -webkit-box;
  max-width: 200px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const BodyCard = styled.div`
  width: 100%;
  text-align: left;
`;

export const FooterCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const TextDescription = styled.p`
  font-family: "Inter Regular";
  color: var(--textLight);
  font-size: 15px;
  margin-bottom: 15px;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Value = styled.span`
  font-family: "Inter Medium";
  font-size: 18px;
`;

export const Time = styled.span`
  display: block;
  font-family: "Inter Regular";
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 50px;
  background: var(--backgroundColor);
`;

export const ListItemPlans = styled.ul`
  padding: 0;
  margin-bottom: 10px;
`;

export const ItemPlans = styled.li`
  display: block;
  font-family: "Inter Medium";
  font-size: 16px;
  color: var(--textLight);
  position: relative;
  padding-left: 10px;

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 10px;
    width: 5px;
    height: 5px;
    border-radius: 50px;
    background: var(--primarySystem100);
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;
